module.exports = __webpack_public_path__ + "img/元素8.f4088df8.png";